import { forwardRef } from 'react';
import { CellulaDropdownMenuItem } from './dropdown_menu_item.component';
import { CellulaDropdownMenuRoot, DropdownMenuRootProps } from './dropdown_menu_root.component';

export const DropdownMenu = {
	Root: forwardRef(CellulaDropdownMenuRoot),
	Item: forwardRef(CellulaDropdownMenuItem),
} as const;

export type { DropdownMenuRootProps };
